import {
  IoHourglassOutline,
  IoRocketOutline,
  IoTimeOutline,
} from "react-icons/io5";
import "./StatusBanner.css";

const statusConfig = {
  coming_soon: {
    icon: IoHourglassOutline,
    text: "Coming Soon",
    className: "status-coming-soon",
  },
  in_review: {
    icon: IoTimeOutline,
    text: "Awaiting Review",
    className: "status-in-review",
  },
  releasing_soon: {
    icon: IoRocketOutline,
    text: "Available Tomorrow",
    className: "status-releasing-soon",
  },
};

export default function StatusBanner({ status, customMessage, className = "" }) {
  if (status === "available") return null;

  const config = statusConfig[status];
  if (!config) return null;

  const Icon = config.icon;
  const displayText = customMessage || config.text;

  return (
    <div
      className={["status-banner", config.className, className].filter(Boolean).join(" ")}
      aria-label={displayText}
    >
      <Icon className="status-banner-icon" aria-hidden="true" />
      <span className="status-banner-text">{displayText}</span>
    </div>
  );
}
